import { PropTypes } from 'prop-types';
import React from 'react';

import { TaskTemplateModes } from '@ge/models/constants';

import { CreateNoteAttachment } from './create-note-attachment';
import { EditNoteAttachment } from './edit-note-attachment';

export const NoteAttachmentSection = ({ section, templateMode }) => {
  const { collapsed, metadata } = section;

  if (!section.hidden) {
    switch (templateMode) {
      case TaskTemplateModes.CREATE:
        return <CreateNoteAttachment collapsed={collapsed} metadata={metadata} />;
      case TaskTemplateModes.EDIT:
        return <EditNoteAttachment metadata={metadata} />;
      default:
        return null;
    }
  }
};

NoteAttachmentSection.propTypes = {
  section: PropTypes.object.isRequired,
  templateMode: PropTypes.oneOf(Object.values(TaskTemplateModes)).isRequired,
};
